module.exports = __webpack_public_path__ + "static/zero-8369b5b6a5c8f86382a15adde1a75a20.jpg";